import {FiltreItem, FiltreItems} from "./filtre-item";
import {Component, EventEmitter, Input, Output} from "@angular/core";
import * as lodash from "lodash";

@Component({
  selector: 'factures-vos-filtres',
  templateUrl: './vos-filtres.component.html'
})
export class FacturesVosFiltresComponent {

  @Input() titre: string
  @Input() filtre: FiltreItems;

  @Output() onItemRemoved = new EventEmitter<FiltreItem>();
  @Output() onCreated = new EventEmitter<FiltreItems>();
  @Output() onUpdated = new EventEmitter<FiltreItems>();

  constructor() {
  }

  remove(removedFiltre: FiltreItem, removedValue: any): void {
    if (removedValue == null) {
      lodash.remove(this.filtre.filtres, (filtre) => {
        return removedFiltre.code == filtre.code;
      });
    } else {
      lodash.remove(removedFiltre.value, (value) => {
        return removedValue == value;
      });
    }
    this.onItemRemoved.emit(removedFiltre);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-factures/digicerba-factures-web/src/angular/cerba/src/app/pages/cerba/pages/factures/filtres/vos-filtres/vos-filtres.component.ts